import { ApolloLink } from "./ApolloLink.js";
export var from = ApolloLink.from;
//# sourceMappingURL=from.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@apollo/client/link/core/from.js
// module id = ./node_modules/@apollo/client/link/core/from.js
// module chunks = 54 55